/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { i as isNumber_1 } from '../../_chunks/dep-0e15088f.js';
import { i as isString_1 } from '../../_chunks/dep-6c5254c6.js';
import { g as get_1 } from '../../_chunks/dep-337b4140.js';
import useConfig from '../../hooks/useConfig.js';
import useDomRefCallback from '../../hooks/useDomRefCallback.js';
import useRipple from '../../_util/useRipple.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-33ffecad.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_util/easing.js';

var componentType = "select";
var Option = function Option(props) {
  var _classNames2;
  var propDisabled = props.disabled,
    propLabel = props.label,
    propTitle = props.title,
    selectedValue = props.selectedValue,
    checkAll = props.checkAll,
    multiple = props.multiple,
    size = props.size,
    max = props.max,
    keys = props.keys,
    value = props.value,
    onSelect = props.onSelect,
    children = props.children,
    content = props.content,
    restData = props.restData,
    style = props.style,
    className = props.className,
    isVirtual = props.isVirtual;
  var selected;
  var label = propLabel || value;
  var disabled = propDisabled || multiple && Array.isArray(selectedValue) && max && selectedValue.length >= max;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useDomRefCallback = useDomRefCallback(),
    _useDomRefCallback2 = _slicedToArray(_useDomRefCallback, 2),
    optionRef = _useDomRefCallback2[0],
    setRefCurrent = _useDomRefCallback2[1];
  useEffect(function () {
    if (isVirtual && optionRef) {
      var _props$onRowMounted;
      (_props$onRowMounted = props.onRowMounted) === null || _props$onRowMounted === void 0 ? void 0 : _props$onRowMounted.call(props, {
        ref: optionRef,
        data: props
      });
    }
  }, [isVirtual, optionRef]);
  useRipple(optionRef);
  if (!multiple) {
    selected = isNumber_1(selectedValue) || isString_1(selectedValue) ? value === selectedValue : value === get_1(selectedValue, (keys === null || keys === void 0 ? void 0 : keys.value) || "value");
  }
  if (multiple && Array.isArray(selectedValue)) {
    selected = selectedValue.some(function (item) {
      if (isNumber_1(item) || isString_1(item)) {
        return item === value;
      }
      return get_1(item, (keys === null || keys === void 0 ? void 0 : keys.value) || "value") === value;
    });
    if (props.checkAll) {
      selected = selectedValue.length === props.optionLength;
    }
  }
  var handleSelect = function handleSelect(event) {
    if (!disabled && !checkAll) {
      onSelect(value, {
        label: String(label),
        selected: selected,
        event: event,
        restData: restData
      });
    }
    if (checkAll) {
      var _props$onCheckAllChan;
      (_props$onCheckAllChan = props.onCheckAllChange) === null || _props$onCheckAllChan === void 0 ? void 0 : _props$onCheckAllChan.call(props, selected, event);
    }
  };
  var renderItem = function renderItem(children2) {
    if (multiple) {
      var _classNames;
      return /* @__PURE__ */React.createElement("label", {
        className: classNames("".concat(classPrefix, "-checkbox"), (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-is-disabled"), disabled), _defineProperty(_classNames, "".concat(classPrefix, "-is-checked"), selected), _classNames))
      }, /* @__PURE__ */React.createElement("input", {
        type: "checkbox",
        className: classNames("".concat(classPrefix, "-checkbox__former")),
        value: "",
        disabled: disabled && !selected,
        onClick: function onClick(e) {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        }
      }), /* @__PURE__ */React.createElement("span", {
        className: classNames("".concat(classPrefix, "-checkbox__input"))
      }), /* @__PURE__ */React.createElement("span", {
        className: classNames("".concat(classPrefix, "-checkbox__label"))
      }, children2 || content || label));
    }
    return /* @__PURE__ */React.createElement("span", {
      title: propTitle || label
    }, children2 || content || label);
  };
  return /* @__PURE__ */React.createElement("li", {
    className: classNames(className, "".concat(classPrefix, "-").concat(componentType, "-option"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(classPrefix, "-is-disabled"), disabled), _defineProperty(_classNames2, "".concat(classPrefix, "-is-selected"), selected), _defineProperty(_classNames2, "".concat(classPrefix, "-size-s"), size === "small"), _defineProperty(_classNames2, "".concat(classPrefix, "-size-l"), size === "large"), _classNames2)),
    key: value,
    onClick: handleSelect,
    ref: setRefCurrent,
    style: style
  }, renderItem(children));
};

export { Option as default };
//# sourceMappingURL=Option.js.map
